import { useMutation } from 'react-query';
import axios from '../../../utils/axios';
import { apiurl } from '../../../config/apiUrl';

const getLevelTwoPurposeQuery = (id) => {
    if (id) {
        return axios.get(`${apiurl?.getLevelTwoPurpose}?purposeId=${id}`);
    }
    return [];
};

const getLevelTwoPurpose = () => {
    return useMutation(['getLevelTwoPurpose'], getLevelTwoPurposeQuery);
};

export default getLevelTwoPurpose;
